import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "theme/theme.js";

import AuthLayout from "layouts/Auth.js";
import DocumentationLayout from "layouts/Documentation";
import AdminLayout from "layouts/Admin.js";
import Home from "layouts/Home";
import SplashScreen from "components/SplashScreen/SplashScreen";

function App() {
  return (
    <ChakraProvider theme={theme}>
      <SplashScreen />
      <BrowserRouter>
        <Switch>
          <Route path="/home" component={Home} />
          <Route path="/auth" component={AuthLayout} />
          <Route path="/txd" component={AdminLayout} />
          <Route path="/docs" component={DocumentationLayout} />
          <Redirect from="/" to="/home" />
        </Switch>
      </BrowserRouter>
    </ChakraProvider>
  );
}

ReactDOM.render(<App />, document.getElementById("root"));

